<template>
    <div class="progress-bar-container" :class="[{ 'vertical': isCourseListItem }]">
        <div class="progress-bar__progress-text" v-if="!isCourseListItem">
            <number
                ref="animatedProgress"
                :from="0"
                :to="getProgress"
                :duration="2"
                :delay="0"
                easing="Power1.easeOut"
            />
            <span class="progress-bar__completed-text" v-html="$t('CourseProgressBar.completed')"></span>
        </div>
        <div v-if="progress !== null" :class="['progress-bar', { 'course-list-item': isCourseListItem }]">
            <span
                :class="[
                    'progress-bar__indicator',
                    { '-completed': progress >= 100 || isCompleted }
                ]"
                :style="{ width: `${getProgress}%` }"
            >
            </span>
        </div>
        <div class="progress-bar__progress-text" v-if="isCourseListItem" :class="[{ 'course-list-item': isCourseListItem }]">
            <number
                ref="animatedProgress"
                :from="0"
                :to="getProgress"
                :duration="2"
                :delay="0"
                easing="Power1.easeOut"
            />
            <span class="progress-bar__completed-text" v-html="$t('CourseProgressBar.completed')"></span>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'course-progress-bar',
        props: {
            progress: {
                type: Number,
                default: null
            },
            isCompleted: {
                type: Boolean,
                default: null
            },
            completedDate: {
                type: String,
                default: null
            },
            isCourseListItem: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            showProgress () {
                return this.progress >= 0
            },
            getProgress () {
                if (this.progress === null || !this.isLoggedIn) {
                    return 0
                }
                if (!this.isCompleted && this.progress > 100) {
                    return 99
                }
                if ((this.isCompleted) || (this.progress > 100)) {
                    return 100
                }
                return this.progress
            }
        },
        methods: {
            playAnimation () {
                this.scaleClass = false
                this.$refs.animatedProgress.play()
            }
        }
    }
</script>

<style lang="scss" scoped>

    .progress-bar-container {
        margin: 20px 0 0px 0px;
    
        [class*="mobile"] & {
            min-height: 35px;
        }

        &.vertical {
            margin: 0;
        }

    }

    .progress-bar {
        width: 100%;
        height: 10px;
        background: $white;
        display: flex;
        line-height: 30px;
        border-radius: 40px;
        flex-direction: column;
        position: relative;

        &.is-not-started {
            background: $white;
        }

        &.course-list-item {
            background: $bright_gray;
        }

        [class*="mobile"] & {
            height: 8px;
            font-size: 1rem;
        }

        &__indicator {
            position: absolute;
            height: 10px;
            [class*="mobile"] & {
                height: 8px;
            }
        }

        &__indicator {
            &:after {
                content: '';
                position: absolute;
                left: 0;
                width: 0;
                height: 100%;
                animation: load 2s;
                animation-timing-function: ease-out;
                animation-fill-mode: both;
                border-radius: 40px;
            }
            &.-completed:after {
                animation: load-completed 2s;
                animation-timing-function: ease-out;
                animation-fill-mode: both;
            }
        }

        &__indicator-banner {
            background: $steam;
            height: 35px;
            [class*="mobile"] & {
                height: 30px;
            }
        }

        &__indicator-banner:after {
            border-radius: 0 30px 30px 0;
        }

        @keyframes load {
            0% {
                width: 0;
                background: $amber;
            }
            100% {
                width: 100%;
                background: $amber;
            }
        }

        @keyframes load-completed {
            0% {
                width: 0;
                background: $green;
            }
            100% {
                width: 100%;
                background: $green;
            }
        }

        &__progress {
            margin: 0 auto;
            z-index: 1;
            display: flex;
            align-items: center;
        }

        &__progress-text {
            color: $tuatara;
            font-size: 1.4rem;
            white-space: nowrap;
            position: relative;
            margin: 0px 0px 6px 0px;

            &.course-list-item {
                font-size: 1.2rem;
                margin: 5px 0 0 0;
            }
        }

        .icon-checked {
            font-size: 1.8rem;
            margin: 0 5px;
            [class*="mobile"] & {
                font-size: 1.4rem;
            }
        }

        &__completed-text {
            position: absolute
        }
}
</style>
